import { Box, Flex, Image, Separator } from '@chakra-ui/react';
import { VStack, HStack, Heading, Text, Button, Link } from 'components/ui';
import { AutoScrollCarousel } from './AutoScrollCarousel';

import { CoBrandingLogo } from '../../CoBrandingLogo';
import { useAffiliate } from '../../../../api/affiliates/useAffiliate';
import { useNavigateWithParams } from '../../../../hooks/useNavigateWithParams';
import { TRACKING_LANDING_PAGE_CTA } from '../../../OnboardingForm/constants';

const aybleLogo = '/FA__ayble_health_Logo_Isabelline.png';

const benefits = [
  { text: 'Have regular bowel movements every day', emoji: '💩' },
  { text: 'Reduce symptoms like heartburn, pain, diarrhea', emoji: '☺️' },
  { text: 'Feel confident eating out and in social settings', emoji: '🥗' },
  { text: 'Wear favorite clothes again without bloat worries', emoji: '👚' },
  { text: 'Enjoy food without guess-work or over-restricting', emoji: '🍱' },
  { text: 'Minimize nighttime bathroom wake-ups', emoji: '😴' },
];

export const HeroSection = ({ onStartOnboarding, startOnboardingError }) => {
  const { affiliate } = useAffiliate();
  const navigate = useNavigateWithParams();

  return (
    <Flex direction="column">
      <Button
        color="secondary.500"
        fontSize="17px"
        py={8}
        onClick={() => navigate('/login')}
        alignSelf="flex-end"
        variant="link"
        _hover={{
          bg: 'transparent',
          color: 'secondary.500',
          textDecoration: 'underline',
        }}
        _active={{ bg: 'transparent', color: 'secondary.500' }}
      >
        Login
      </Button>
      <Flex direction={{ base: 'column', lg: 'row' }} alignItems={'center'}>
        <VStack
          gap={{ base: 7, lg: 10 }}
          w={{ base: '85%', md: '50%', xl: '27%' }}
          mx={'auto'}
          align={{ base: 'center', lg: 'flex-start' }}
        >
          <HStack
            align="center"
            justify={{ base: 'center', lg: 'flex-start' }}
            w="100%"
          >
            <CoBrandingLogo variant="new" />
            <Image
              src={aybleLogo}
              alt="Ayble logo"
              h={'50px'}
              w={'80px'}
              objectFit="contain"
            />
          </HStack>
          <Heading
            color={'secondary.500'}
            fontSize={'4xl'}
            fontWeight={400}
            textAlign={{ base: 'center', lg: 'left' }}
          >
            {affiliate?.landing_page_top_header || 'Digestive Care for the Whole You'}
          </Heading>
          <Text
            color={'secondary.200'}
            fontSize={'xl'}
            textAlign={{ base: 'center', lg: 'left' }}
          >
            {affiliate?.landing_page_top_body ||
              'Your provider and Ayble are teaming up to offer at-home GI nutrition and mental health support'}
          </Text>
          {startOnboardingError && (
            <Text color={'red.500'}>
              {startOnboardingError} Contact{' '}
              <Link
                href={'mailto:support@ayblehealth.com'}
                _text={{
                  textTransform: 'none',
                  color: 'red.500',
                  fontWeight: 'normal',
                }}
              >
                support@ayblehealth.com
              </Link>{' '}
              for help or to manage your subscription.
            </Text>
          )}
          <Button
            backgroundColor={'secondary.200'}
            color="white"
            textTransform="capitalize"
            fontSize="md"
            fontWeight={600}
            w="362px"
            alignSelf={{ base: 'center', lg: 'flex-start' }}
            onClick={() => onStartOnboarding(TRACKING_LANDING_PAGE_CTA)}
          >
            Get Started →
          </Button>
        </VStack>

        <Image
          display={{ base: 'none', lg: 'block' }}
          src={'/coach_hero.png'}
          alt="Patient interacting with coach"
          w={{ md: '500px', lg: '500px', xl: '700px' }}
          h="557px"
          borderLeftRadius={'xl'}
          objectFit="cover"
        />
      </Flex>
      <HStack
        display={{ base: 'none', lg: 'flex' }}
        maxW={{ md: '94%', xl: '86%' }}
        ml={'auto'}
        alignItems="center"
        mt={8}
      >
        <Box mr={'-120px'}>
          <Text fontSize="lg" w={{ base: '60%', xl: '65%' }}>
            Whatever your{' '}
            <Box display={'inline'} color="#5299A9" fontWeight={600}>
              gut health goal
            </Box>
            , Ayble can help
          </Text>
        </Box>

        <AutoScrollCarousel cardContent={benefits} />
      </HStack>

      <Box mt={10} display={{ base: 'block', lg: 'none' }}>
        <AutoScrollCarousel cardContent={benefits} />
        <Image
          src={'/coach_hero.png'}
          alt="Patient interacting with coach"
          h="340px"
          objectFit="cover"
          mt={2}
        />
      </Box>
      <Separator
        maxW={'80%'}
        mx={'auto'}
        mt={10}
        borderColor={'#E7E7E7'}
        display={{ base: 'none', lg: 'block' }}
      />
    </Flex>
  );
};
